import ScrollMagic from 'scrollmagic';
import { getScrollY } from './utility';

export default function inview() {
  const scrollMagic = new ScrollMagic.Controller();
  const inviewElements = [];
  const setInview = (element) => {
    const dataInviewPosition = element.dataset.inviewPosition;
    const inviewPosition =
      typeof dataInviewPosition === 'undefined' ? 0.9 : Number(dataInviewPosition);

    inviewElements.push(
      new ScrollMagic.Scene({
        triggerElement: element,
        triggerHook: inviewPosition,
        reverse: false,
      })
        .setClassToggle(element, '-inview')
        .on('update', (event) => {
          const contentHeight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.clientHeight,
            document.documentElement.scrollHeight,
            document.documentElement.offsetHeight,
          );
          const scrollLimit =
            contentHeight - document.documentElement.clientHeight * (1 - inviewPosition);
          const elementPosition = element.getBoundingClientRect().top + getScrollY();

          event.currentTarget.triggerHook(
            elementPosition >= scrollLimit
              ? (document.documentElement.clientHeight - (contentHeight - elementPosition)) /
                  document.documentElement.clientHeight
              : inviewPosition,
          );
        })
        .addTo(scrollMagic),
    );
  };
  document.querySelectorAll('.js-inview').forEach(setInview);

  const modalNodeList = document.querySelectorAll('.Modal');
  const manageInview = () => {
    inviewElements.forEach((element) => {
      if ('inviewModal' in element.triggerElement().dataset) {
        const modalElement = element.triggerElement().closest('.Modal');

        if (modalElement === null) return;

        element.enabled(modalElement.getAttribute('aria-hidden') !== 'true');
      }
    });
  };

  manageInview();

  modalNodeList.forEach((element) => {
    new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'aria-hidden' &&
          mutation.oldValue === 'true' &&
          mutation.target.getAttribute('aria-hidden') === 'false'
        ) {
          observer.disconnect();
          setTimeout(() => {
            manageInview();
          }, 100);
        }
      });
    }).observe(element, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['aria-hidden'],
    });
  });
}
